import(/* webpackMode: "eager" */ "/app/src/app/api/page.tsx");
